// Emails link to /companies/<slug>?shortlist=1 to save the company to the user's default list.
// The company's shortlist button does the saving, when it sees the 'auto-shortlist-company' flag for its company.

const SHORTLIST_PARAM = 'shortlist';
const AUTO_SHORTLIST_KEY = 'auto-shortlist-company';

export function shouldShortlistFromLink(search: string) {
  return new URLSearchParams(search).get(SHORTLIST_PARAM) === '1';
}

/** Sets the flag for the company's shortlist button and removes the parameter, so a reload doesn't save it again. */
export function saveShortlistFromLink(companySlug: string) {
  if (!shouldShortlistFromLink(window.location.search)) {
    return;
  }
  try {
    window.localStorage?.setItem(AUTO_SHORTLIST_KEY, JSON.stringify(companySlug));
  } catch {
    // Local storage is best effort
  }
  const url = new URL(window.location.href);
  url.searchParams.delete(SHORTLIST_PARAM);
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
}
